import { useLocation } from 'react-router-dom';
import { useStoreSelector } from '../../..';
import {
  getActualAttributes,
  getActualpriceAdditional,
} from '../../../store/selectors/selectors';
import { assetID } from '../../../utils/constants';

export function useCartActions() {
  const location = useLocation();
  const actualAttributes: any = useStoreSelector(getActualAttributes);
  const actualpriceAdditional: any = useStoreSelector(getActualpriceAdditional);

  function addToCart() {
    const arrayOfMetaData: any = [];
    const nameJeep = assetID[location.pathname] || 'Jeep4DoorJL';

    Object.keys(actualAttributes).forEach((key: any) => {
      let obg: any = {
        fcid: undefined,
        node_id: undefined,
        product_id: undefined,
        sku: undefined,
      };

      if (
        key === 'Lift' ||
        key === 'Wrangler Model' ||
        key === 'Shock Options'
      ) {
        if (key === 'Shock Options') {
          obg = {
            ...obg,
            label: 'Lift',
            id: actualAttributes[key].id,
            quantity: actualAttributes[key].shopInfo.quantity,
            category: key,
          };
          if (actualAttributes[key].id) {
            obg = {
              ...obg,
              ...actualpriceAdditional[actualAttributes[key].id],
            };
          }
          arrayOfMetaData.push(obg);
        }
      } else {
        if (actualAttributes[key].activeItemId) {
          obg = {
            ...obg,
            label: actualAttributes[key].activeItem,
            id: actualAttributes[key].activeItemId,
            quantity: actualAttributes[key].shopInfo.quantity,
            category: key,
          };
          obg = {
            ...obg,
            ...actualpriceAdditional[actualAttributes[key].activeItemId],
          };
          arrayOfMetaData.push(obg);
        } else {
          obg = {
            ...obg,
            label: actualAttributes[key].activeItem,
            quantity: actualAttributes[key].shopInfo.quantity,
            category: key,
          };
          if (actualAttributes[key].activeItemId) {
            obg = {
              ...obg,
              ...actualpriceAdditional[actualAttributes[key].activeItemId],
            };
          }
          arrayOfMetaData.push(obg);
        }
      }
    });

    const jsonMessage = {
      type: 'ADD_TO_CART',
      jeepName: nameJeep,
      data: arrayOfMetaData,
    };
    console.log('jsonMessage: ', jsonMessage);
    window.parent.postMessage(jsonMessage, '*');
  }

  return { addToCart };
}
